import { Button } from "@chakra-ui/react";

const SubmitButton = ({
  isLoading,
  text,
  backColor,
  textColor,
  onClickHandler,
  hoverColor,
}) => {
  return (
    <Button
      isLoading={isLoading}
      bg={backColor}
      py={6}
      px={20}
      color={textColor}
      fontWeight={500}
      onClick={onClickHandler}
      _hover={{ bg: hoverColor }}
    >
      {text}
    </Button>
  );
};

export default SubmitButton;
